<form [formGroup]="impactPartnerForm" (submit)="onSubmit()">
  <app-input-wrapper>
    <label>Media Partner ID<span>*</span></label>
    <input
      type="text"
      placeholder="Media Partner Id "
      inNoWhitespace
      formControlName="mediaPartnerId"
      maxlength="100"
    />
    <span
      *ngIf="impactPartnerForm.get('mediaPartnerId')?.errors?.['required']&&(impactPartnerForm.get('mediaPartnerId')?.dirty||impactPartnerForm.get('mediaPartnerId')?.touched)"
    >
      Media Partner Id is required
    </span>
  </app-input-wrapper>

  <app-input-wrapper>
    <label>Partner Name<span>*</span></label>
    <input
      type="text"
      placeholder="Partner Name"
      inNoWhitespace
      formControlName="name"
      maxlength="100"
    />
    <span
      *ngIf="impactPartnerForm.get('name')?.errors?.['required']&&(impactPartnerForm.get('name')?.dirty||impactPartnerForm.get('name')?.touched)"
    >
      Partner Name is required
    </span>
  </app-input-wrapper>

  <app-input-wrapper>
    <app-multiselect-dropdown
      [maxHeight]="'180px'"
      [multiselect]="false"
      [searchable]="true"
      [config]="countryCodeConfig"
      [options]="countryCodesOptions"
      [control]="impactPartnerForm.get('countryCode')"
      (searchEvent)="handleSearch($event)"
      [error]="(impactPartnerForm.get('countryCode')?.errors?.['required']&&(impactPartnerForm.get('countryCode')?.dirty||impactPartnerForm.get('countryCode')?.touched))?'Country Code is required':''"
    >
    </app-multiselect-dropdown>
  </app-input-wrapper>
  <app-input-wrapper>
    <label>Associated Phone No. <span>*</span></label>
    <input
      type="text"
      formControlName="phone"
      placeholder="Enter phone"
      inNoWhitespace
      mask="(000) 000-0000"
    />
    <span
      *ngIf="impactPartnerForm.get('phone')?.errors?.['required']&&(impactPartnerForm.get('phone')?.dirty||impactPartnerForm.get('phone')?.touched)"
    >
      Phone No. is required
    </span>
    <span
      *ngIf="impactPartnerForm.get('phone')?.errors?.['mask']&&(impactPartnerForm.get('phone')?.dirty||impactPartnerForm.get('phone')?.touched)"
    >
      Phone No. is invalid
    </span>
  </app-input-wrapper>
  <div class="blog-action__footer flex justify-end">
    <app-button
      customClass="outline"
      label="cancel"
      type="button"
      (action)="handleClose()"
    >
    </app-button>
    <app-button
      type="submit"
      [label]="editPartner ? 'Update' : 'Submit'"
      [isDisabled]="isLoading"
    >
      <app-button-loader *ngIf="isLoading" postfixContent></app-button-loader>
    </app-button>
  </div>
</form>
